import { alpha, useTheme } from "@mui/material/styles";
import { useEffect } from "react";

function ThemeCssVarsSync() {
  const theme = useTheme();

  useEffect(() => {
    const root = document.documentElement;
    const p = theme.palette;
    root.classList.toggle("dark", theme.palette.mode === "dark");
    root.style.setProperty("--erp-bg-default", p.background.default);
    root.style.setProperty("--erp-bg-paper", p.background.paper);
    root.style.setProperty("--erp-bg-alt", p.background.alt ?? p.background.default);
    root.style.setProperty("--erp-text-primary", p.text.primary);
    root.style.setProperty("--erp-text-secondary", p.text.secondary);
    root.style.setProperty("--erp-primary-main", p.primary.main);
    root.style.setProperty("--erp-primary-dark", p.primary.dark);
    root.style.setProperty("--erp-primary-light", p.primary.light);
    root.style.setProperty("--erp-secondary-main", p.secondary.main);
    root.style.setProperty("--erp-divider", p.divider);
    root.style.setProperty(
      "--erp-brand-50",
      alpha(p.primary.main, theme.palette.mode === "dark" ? 0.12 : 0.06),
    );
    root.style.setProperty(
      "--erp-brand-100",
      alpha(p.primary.main, theme.palette.mode === "dark" ? 0.18 : 0.1),
    );
    root.style.setProperty("--erp-success-main", p.success.main);
    root.style.setProperty(
      "--erp-success-surface",
      alpha(p.success.main, theme.palette.mode === "dark" ? 0.15 : 0.12),
    );
    root.style.setProperty("--erp-warning-main", p.warning.main);
    root.style.setProperty(
      "--erp-warning-surface",
      alpha(p.warning.main, theme.palette.mode === "dark" ? 0.15 : 0.12),
    );
    root.style.setProperty(
      "--erp-slate-surface",
      theme.palette.mode === "dark"
        ? alpha(p.common.white, 0.08)
        : alpha(p.common.black, 0.04),
    );
    root.style.setProperty("--erp-page", p.background.default);
  }, [theme]);

  return null;
}

export { ThemeCssVarsSync };
